import { RouteConfig } from 'vue-router'
import Page from '@/Core/views/Page/Page.vue'
import List from './pages/List/List.vue'
import { Roles } from '../UsersManager/models'

export enum UnprocessedFilesPages {
  List = 'unprocessed-list',
  MarketerList = 'unprocessed-marketer-list'
}

const routes: Array<RouteConfig> = [
  {
    path: '/unprocessed',
    component: Page,
    children: [
      {
        path: '',
        name: UnprocessedFilesPages.List,
        meta: { menuActive: 'unprocessed', denyRolesAcess: [Roles.Marketer.code] },
        component: List
      }
    ]
  }
]

export default routes
